export type ISetFieldValue = (
  fieldId: string,
  value: string,
  suffix?: string,
  triggerChange?: boolean,
  displayValue?: string
) => void;

export function setFieldValue(
  fieldId: string,
  value: string,
  suffix?: string,
  triggerChange?: boolean,
  displayValue?: string
): void {
  // Consstruct field suffix
  let _suffix = typeof window.fieldSuffix !== 'undefined' ? window.fieldSuffix : '';
  if (suffix) {
    _suffix = suffix;
  }
  const inputSelector = `:input[name="${fieldId}${_suffix}"]`;
  const siblingAutoinputSelector = `:input[name="auto_${fieldId}${_suffix}"]`;
  const $input = $(inputSelector);
  if (!$input.length) {
    return;
  }
  const $autoField = $(siblingAutoinputSelector);
  const node = $input[0].nodeName.toLowerCase();
  const type = $input.attr('type');
  const $parentReadOnlySpan = $input.parent('.display-only-input');
  const $displayValueHolder = $parentReadOnlySpan.find('.display-only-display-value');
  // If it's a button, ignore it
  if (node === 'input' && (type === 'button' || type === 'submit' || type === 'reset')) {
    return;
  }

  // If element is in display only mode, place value inside the display-only-display-value span
  if ($parentReadOnlySpan.length) {
    $displayValueHolder.empty().text(displayValue || value);
  }

  // Input text, password and hidden
  if (node === 'input' && (type === 'text' || type === 'password' || type === 'hidden')) {
    // Insert value into input
    $input.val(value);
    ($ as any).log(`setFieldValue for ${$input.attr('name')}  =  ${value}`);

    if (value !== null && $.type(value) === 'string' && value.indexOf('~:~') > 0) {
      if ($autoField.length) {
        $input.val(value.substring(0, value.indexOf('~:~')));
        $autoField.val(value.substring(value.indexOf('~:~') + 3));
      }
    } else if (value !== null && $.type(value) === 'string' && value.indexOf(',') > 0) {
      if (($input.attr('name') as string).endsWith('_lat')) {
        $input.val(value.substring(0, value.indexOf(',')));
      } else if (($input.attr('name') as string).endsWith('_long')) {
        $input.val(value.substring(value.indexOf(',') + 1));
      }
    }
    // Radio and checkboxes
  } else if (node === 'input' && (type === 'radio' || type === 'checkbox')) {
    $input.each((_, elm) => {
      const $elm = $(elm);
      if (String($elm.val()) === value.toString()) {
        $elm.prop('checked', true);
        ($ as any).log(`setFieldValue for ${$elm.attr('name')}  =  ${value}`);
      } else {
        ($ as any).log(`Unable to setFieldValue for ${$elm.attr('name')}  =  ${value}`);
      }
    });
    // Select dropdown
  } else if (node === 'select') {
    let selectHasValue = false;
    $input.find('option').each((_, opt) => {
      if (String($(opt).val()) === value.toString()) {
        $input.val(value);
        selectHasValue = true;
      } else if (
        $(opt)
          .text()
          .toString() === value.toString()
      ) {
        $input.val(String($(opt).val()));
        selectHasValue = true;
      }
    });
    if (selectHasValue) {
      ($ as any).log(`setFieldValue for ${$input.attr('name')}  =  ${value}`);
    } else {
      ($ as any).log(`Unable to setFieldValue for ${$input.attr('name')}  =  ${value}`);
    }
  } else if (node === 'textarea') {
    $input.val(value);
  } else {
    ($ as any).log(`Unknown node type: ${node}`);
  }
  $input.removeClass('defaultValue');
  if (triggerChange) {
    $input.trigger('change');
  }
}
